import { render, staticRenderFns } from "./SalarySplitTable.vue?vue&type=template&id=76a7858a&scoped=true&"
import script from "./SalarySplitTable.vue?vue&type=script&lang=js&"
export * from "./SalarySplitTable.vue?vue&type=script&lang=js&"
import style0 from "./SalarySplitTable.vue?vue&type=style&index=0&id=76a7858a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a7858a",
  null
  
)

export default component.exports